export const queryTool = {
  schema: {
    name: 'query_knowledge_base',
    description: 'Query the knowledge base. All the documents mentioned are contained here. ALWAYS CHECK BEFORE ANSWERING, you might find something unexpected',
    parameters: {
      type: 'object',
      properties: {
        query: {
          type: 'string',
          description: 'query to search the knowledge base',
        },
        file_name: {
          type: 'string',
          description: 'Optional: Filter results to a specific file. Extension must be specified, try .docx if unknown.',
        }
      },
      required: ['query'],
    },
  },
  fn: async ({ query, file_name }: { query: string; file_name?: string }): Promise<any> => {
    try {
      const RAG_API_URL = process.env.REACT_APP_RAG_API_URL + '/query';
      
      const requestBody: any = {
        query,
        // retriever_type: "fusion",
        k: 6,
        // summary: false
      };

      // Only add file_name if it's provided
      if (file_name) {
        requestBody.file_name = file_name;
      }

      const response = await fetch(RAG_API_URL, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer',
        headers: {
          // 'accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error(`Query failed with status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error querying the index:", error);
      throw error;
    }
  }
};

// Export the tool
export default queryTool;
